<template>
  <div :style="botMessageStyle">
    <div v-dompurify-html="formattedContent" class="message-content" :class="{'dark-theme': isDarkTheme}" style="white-space: normal; display: inline;"></div>
  </div>
</template>
<script>
import showdown from 'showdown';
import showdownHighlight from 'showdown-highlight';
import katex from 'katex';
import splitAtDelimiters from "katex/contrib/auto-render/splitAtDelimiters";
import 'katex/dist/katex.min.css'
import 'highlight.js/styles/monokai.min.css'
import {inject} from "vue";

const converter = new showdown.Converter({
  extensions:[
    showdownHighlight({
      pre:true
    })
  ],
  simpleLineBreaks:true,
  disableForced4SpacesIndentedSublists:true,
  openLinksInNewWindow:true,
  literalMidWordUnderscores:true
});
const processLaTeXAndMarkdown = (res)=>{
  try {
    let delimiters = [
      {left: "$$", right: "$$", display: true},
      {left: "\\(", right: "\\)", display: false},
      {left: "\\begin{equation}", right: "\\end{equation}", display: true},
      {left: "\\begin{align}", right: "\\end{align}", display: true},
      {left: "\\begin{alignat}", right: "\\end{alignat}", display: true},
      {left: "\\begin{gather}", right: "\\end{gather}", display: true},
      {left: "\\begin{CD}", right: "\\end{CD}", display: true},
      {left: "\\[", right: "\\]", display: true},
    ]

    // Pre-process the text to ensure URLs are properly handled
    // 1. Add a space after URLs that are followed immediately by a newline
    res = res.replace(/(https?:\/\/[^\s]+)(\n)/g, '$1 $2');

    // 2. Ensure that URLs ending with HTML tags are properly separated
    res = res.replace(/(https?:\/\/[^\s<>]+)(<\/[a-z]+>)/gi, '$1 $2');

    // 3. Handle citations on their own line - pull them up to the previous line
    res = res.replace(/([^\n])\n(\[\d+\](?:\s*,\s*\[\d+\])*)(\s*\n|$)/g, '$1 $2$3');

    let split = splitAtDelimiters(res, [...delimiters, {left: '`', right: '`', display: true}]);
    let hybridText = "";
    let mathBlocks = [];
    for (let i = 0; i < split.length; i++) {
      let chunk = split[i];
      if (chunk.type === 'text') {
        hybridText += chunk.data;
      } else if (chunk.type === 'math') {
        if (chunk.rawData.startsWith("`") && chunk.rawData.endsWith("`")) {
          hybridText += chunk.rawData;
        } else {
          mathBlocks[i] = katex.renderToString(chunk.data, {
            delimiters: delimiters,
            displayMode: chunk.display
          });
          hybridText += '`__KATEX__' + i + '__`';
        }
      }
    }

    hybridText = converter.makeHtml(hybridText);

    for (let i = 0; i < mathBlocks.length; i++) {
      hybridText = hybridText.replace('<code>__KATEX__' + i + '__</code>', mathBlocks[i]);
    }

    if (hybridText.includes('katex') || hybridText.includes('<code')) {
      hybridText = '<h3 class="disclaimer">Code/equations generated by AI may not be fully accurate; please verify content with course materials.</h3>' + hybridText;
    }

    return hybridText ? `<div class="markdown">${hybridText}</div>` : res;
  } catch (e) {
    console.log("Error processing LaTeX/md:", e);
    return res;
  }
}

export default {
  name: 'ChatTextFormatter',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formattedContent: '',
      theme: null,
    }
  },
  created() {
    this.theme = inject('theme')
  },
  computed:{
    isDarkTheme() {
      return this.theme.global.current.dark;
    },
    botMessageStyle() {
      return {
        backgroundColor: this.theme.global.current.colors.botMessages,
        color: this.theme.global.current.colors.botText
      }
    }
  },

  watch:{
    content(newVal) {
      const isQuiz = /^\s*(?:```(?:\s*json)?\s*)?\[\s*\{\s*"question"\s*:/s.test(newVal);
      if (isQuiz) {
        this.formattedContent = 'Generating Quiz.' + '.'.repeat(newVal.length % 4);
      }else {
        this.formattedContent = processLaTeXAndMarkdown(newVal);
      }
    }
  }
}
</script>
